import React from "react";
import { Box, H2, Typography, useI18nContext } from "@procore/core-react";

interface SettingsPanelProps {
   sectionLabel: string;
}

export const SettingsPanel = ({ sectionLabel }: SettingsPanelProps) => {
   const I18n = useI18nContext();

   return (
      <Box padding="lg">
         <H2>{sectionLabel}</H2>
         <Box paddingTop="sm">
            <Typography intent="body" color="gray45">
               {I18n.t("views.company.workforce_planning.settings.coming_soon")}
            </Typography>
         </Box>
      </Box>
   );
};
